import { post } from '../utils/http';

export function userForgetPassword(param) {
    return post('sendVerifyCode', param);
}